import React from "react";
import "../pages/Terms.css";

function Disclaimer() {
  return (
    <div className="container">
      <h1>Disclaimer</h1>
      <p>
        While Unithink Education International Private Limited has attempted to
        make the information on this server as accurate as possible, the
        information on this website server is for personal and/or educational
        use only and is provided in good faith without any express or implied
        warranty. There is no guarantee given as to the accuracy or currency of
        any individual item on the website. Persons accessing the website who
        require confirmation of any information should refer to Unithink’s
        sourcing the information for this website. Unithink does not accept
        responsibility for any loss or damage occasioned by use of the
        information contained on the server nor from any access to the server.
        While Unithink will make every effort to ensure the availability and
        integrity of its resources, it cannot guarantee that these will always
        be available, and/or free of any defects, including viruses. Users
        should take this into account when accessing the resources. All access
        and use is at the risk of the user. Unithink has provided hypertext
        links to a number of other websites as a service to users of this
        website. This service does not mean that Unithink endorses those sites
        or material on them in any way. Unithink is not responsible for the use
        of a hypertext link for which a commercial charge applies. Individual
        users are responsible for any charges that their use may incur.
      </p>
    </div>
  );
}

export default Disclaimer;
